<template>
    <div class="custom-modal-wrap overflow-y-auto  overflow-x-hidden fixed top-0 right-0 left-0 z-[100] md:inset-0 h-modal md:h-full justify-center items-center flex">
        <div class="absolute top-[30px] left-0 flex justify-center items-center  my-0 mx-auto right-0 w-full z-10 text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden">
            <div :class="expandError?'w-[850px]':'w-[650px]'" class="transition-width duration-500 mx-auto mt-10 pt-3 bg-[#464851] px-[16px] py-[16px] rounded-lg">
                <div class="flex justify-center relative pb-5">
                    <span class="text-3xl">{{poTendyType=='tendy'?'Tendy template upload':'Purchase Order Upload'}}</span>
                    <a  @click.prevent="close"  href="" class="right-0 top-2 absolute"><mdicon class="cursor-pointer hover:text-slate-200 " name="close"/></a>
                </div>
                <div class="flex">
                    <div class="px-[16px] py-[16px] bg-[#2B2C32] rounded-xl">  
                        <div class="flex items-center  xl:flex-row flex-col gap-3" :class="(poTendyType=='tendy' || poTendyType=='mbll')?'justify-center':'justify-between'">
                            <div class="w-full xl:w-1/2" v-if="poTendyType!=='mbll'">
                                <div class="input-wrapper">
                                    <button @click="selectUploadType(poTendyType)" v-if="poTendyType=='tendy'" :class="uploadType=='other'?'bg-theme-green/10':'bg-theme-green'" class="border border-theme-green w-full rounded-md px-4 py-2 uppercase tracking-widest text-sm font-medium h-[100px]">Tendy Upload Template</button>
                                    <button @click="selectUploadType(poTendyType)" v-else-if="poTendyType=='aglc' || poTendyType=='ocs'" :class="uploadType=='other'?'bg-theme-green/10':'bg-theme-green'" class="border border-theme-green w-full rounded-md px-4 py-2 uppercase tracking-widest text-sm font-medium h-[100px]">{{(poTendyType==='aglc')?'AGLC PackList':'OCS Purchase Order ASN'}}</button>
                                    <button v-else-if="poTendyType==''" :class="uploadType!=='other'?'bg-theme-green/10':'bg-theme-green'" class="border border-theme-green w-full rounded-md px-4 py-2 uppercase tracking-widest text-sm font-medium h-[100px]">Loading...</button>
                                </div>
                            </div>
                            <div v-if="poTendyType!=='tendy'" class="w-full xl:w-1/2">
                                <div class="input-wrapper relative" tabindex="0">
                                    <button @click="selectUploadType('other')" :class="uploadType=='other'?'bg-theme-green':'bg-theme-green/10'" class="border border-theme-green w-full rounded-md px-4 py-2 uppercase tracking-widest h-[100px]">
                                        <div class="flex items-center gap-2 text-[14px] font-medium">
                                            <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="2" y="1.5" width="25" height="25" rx="12.5" fill="#156743"/>
                                                <rect x="2" y="1.5" width="25" height="25" rx="12.5" stroke="#D7F4E1" stroke-width="3"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2502 7.5498C18.4439 7.5498 18.6158 7.67375 18.6771 7.8575L19.1684 9.33155L20.6425 9.8229C20.8262 9.88415 20.9502 10.0561 20.9502 10.2498C20.9502 10.4435 20.8262 10.6155 20.6425 10.6767L19.1684 11.1681L18.6771 12.6421C18.6158 12.8259 18.4439 12.9498 18.2502 12.9498C18.0565 12.9498 17.8845 12.8259 17.8233 12.6421L17.3319 11.1681L15.8579 10.6767C15.6741 10.6155 15.5502 10.4435 15.5502 10.2498C15.5502 10.0561 15.6741 9.88415 15.8579 9.8229L17.3319 9.33155L17.8233 7.8575C17.8845 7.67375 18.0565 7.5498 18.2502 7.5498Z" fill="white"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2502 13.9998C18.6644 13.9998 19.0002 14.3356 19.0002 14.7498V18.4998C19.0002 18.914 18.6644 19.2498 18.2502 19.2498C17.836 19.2498 17.5002 18.914 17.5002 18.4998V14.7498C17.5002 14.3356 17.836 13.9998 18.2502 13.9998Z" fill="white"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8618 10.0457C10.9532 9.72275 11.2479 9.4998 11.5835 9.4998H12.9169C13.2525 9.4998 13.5472 9.72276 13.6385 10.0457L15.9718 18.2957C16.0845 18.6943 15.8528 19.1088 15.4542 19.2215C15.0556 19.3342 14.6411 19.1025 14.5284 18.7039L12.3495 10.9998H12.1508L9.97188 18.7039C9.85915 19.1025 9.44466 19.3342 9.04608 19.2215C8.6475 19.1088 8.41577 18.6943 8.5285 18.2957L10.8618 10.0457Z" fill="white"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.25019 16.2498C9.25019 15.8356 9.58598 15.4998 10.0002 15.4998H14.5002C14.9144 15.4998 15.2502 15.8356 15.2502 16.2498C15.2502 16.664 14.9144 16.9998 14.5002 16.9998H10.0002C9.58598 16.9998 9.25019 16.664 9.25019 16.2498Z" fill="white"/>
                                            </svg>
                                            <span>Other File Type(s)</span>
                                        </div>
                                        <div class="text-[12px]">{{ selectedOther.title }}</div>
                                    </button>
                                    <div v-if="showDropDown" class="absolute top-18 right-0 w-60   mt-1  z-10 rounded-md shadow-lg">
                                        <div class="absolute right-0 -top-4 right-4 h-0 w-0 border-x-8 border-x-transparent border-b-[16px] border-b-gray-black"></div>
                                        <ul role="listbox" aria-labelledby="listbox-label" aria-activedescendant="listbox-item-3" class="bg-gray-black h-[400px] rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                                            <li  @click.prevent="selectOtherType(otherOption)" v-for="(otherOption,ind) in otherOptions" :key="ind" class="cursor-pointer text-gray-900 hover:bg-theme-green/20 hover:border-l-4 hover:border-l-theme-green border-l-4 border-l-transparent select-none relative py-2 pl-3 pr-9">
                                                <div class="flex items-center">
                                                    <span class="ml-3 block text-white truncate text-[16px]">
                                                        {{ otherOption.title }}
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        
                        <div class="flex flex-col justify-center">
                            <p class="text-sm text-center tracking-wider mt-4">Drag and Drop your order below or upload manually to continue. CSV or XLSX file accepted only.</p>
                            <div v-if="poTendyType" class="text-sm text-center tracking-wider mt-4">
                                <a @click="createXlSheet()" href="#" class="underline text-theme-green">CLICK HERE</a> to download our template. Upload it below to continue
                            </div>
                                
                            <!-- <form> -->
                                <div @dragenter.prevent="dragging=true" @dragover.prevent="dragging=true"  @dragleave.prevent="dragging=false" @drop.prevent="addFile" draggable="false">
                                    <label for="uploadFile" class="self-center cursor-pointer">
                                        <span class="flex justify-center py-9 hover:text-dark-gray" >
                                            <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M34.0013 75.3327V41.9993H0.667969V33.9993H34.0013V0.666016H42.0013V33.9993H75.3346V41.9993H42.0013V75.3327H34.0013Z" fill="#1C1D21"/>
                                            </svg>
                                        </span>
                                    </label>
                                    <input ref="uploadFile" id="uploadFile" class="hidden" type="file" @change="addFile" />
                                    <div v-if="file.name" class="flex justify-center mt-4">
                                        <p class="text-sm text-center tracking-wider text-white underline">{{file.name}}</p>
                                        <a @click.prevent="clearFile" href="" class="ml-4"><mdicon class="cursor-pointer hover:text-white text-theme-red" name="close"/></a>
                                    </div>
                                    <p v-else class="text-sm text-center tracking-wider text-theme-878686">No file uploaded...</p>
                                    <div v-if="error" class="flex justify-center mt-4 text-theme-red break-words">
                                        <svg class="fill-theme-red mr-2 min-h-[24px] min-w-[24px]" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12 17C12.2833 17 12.5208 16.9042 12.7125 16.7125C12.9042 16.5208 13 16.2833 13 16C13 15.7167 12.9042 15.4792 12.7125 15.2875C12.5208 15.0958 12.2833 15 12 15C11.7167 15 11.4792 15.0958 11.2875 15.2875C11.0958 15.4792 11 15.7167 11 16C11 16.2833 11.0958 16.5208 11.2875 16.7125C11.4792 16.9042 11.7167 17 12 17ZM12 13C12.2833 13 12.5208 12.9042 12.7125 12.7125C12.9042 12.5208 13 12.2833 13 12V8C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7167 7 11.4792 7.09583 11.2875 7.2875C11.0958 7.47917 11 7.71667 11 8V12C11 12.2833 11.0958 12.5208 11.2875 12.7125C11.4792 12.9042 11.7167 13 12 13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"/>
                                        </svg>
                                        <div v-if="Array.isArray(errorMsg)">
                                            <span>You have {{errorMsg.length}} error messages, expand the right panel to view them. </span>
                                            <span @click="expandNow" class="text-theme-green underline cursor-pointer">Expand View</span>
                                        </div>
                                        <span v-else>{{errorMsg}}</span>
                                    </div>
                                </div>
                                <div>
                                    <div class="input-wrapper max-w-[120px] mt-6 mx-auto">
                                        <div class="text-xs mb-1 text-center">Fulfillment Time</div>
                                        <div class="flex flex-row border-none rounded bg-gray-black w-full">
                                            <input @paste.prevent :onkeypress="preventNonNumbersAndDecimal" v-model="fulfillTime" min="0" maxlength="4" placeholder="ie. 14" class="block mx-1 tracking-wider bg-gray-black border-0 w-[70px] focus:ring-0 text-sm placeholder-theme-878686 text-theme-white" type="number">
                                            <span class="self-center">Days</span>
                                        </div>
                                    </div>
                                </div>
                            <!-- </form> -->
                            <div class="flex justify-center mt-4">
                                <button @click="checkForWarning" :disabled="!file" class="rounded-lg bg-theme-green cursor-pointer disabled:bg-black disabled:cursor-default disabled:text-gray-black text-white px-[140px] py-[14px] text-sm tracking-wider font-medium">CONTINUE</button>
                            </div>
                        </div>
                    </div>
                    <div v-if="expandError" class="relative ml-2 px-[16px] py-[16px] bg-[#2B2C32] rounded-xl">
                        <div class="flex items-center justify-center">
                            <span class="text-white my-3">Error Message</span>
    
                            <svg @click="collapseNow" class="absolute right-3 cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.7049 16.59L11.1249 12L15.7049 7.41L14.2949 6L8.29492 12L14.2949 18L15.7049 16.59Z" fill="white"/>
                            </svg>
                        </div>
                        <p class="text-xs text-theme-orange my-2" v-for="error in errorMsg" :key="error">{{error}}</p>
                    </div>
                </div>
            </div>
        </div> 

        <price-warning-modal v-if="priceWarning.modal" :title="priceWarning.title" :data="priceWarning.data" @close="closePriceWarningModal" @apply="uploadFile" />
    </div> 
    </template>
    <script>
    import { ref, defineComponent } from 'vue'
    import {mapGetters, mapMutations} from 'vuex'
    import { useSnackbar } from "vue3-snackbar"

    import ProductApi from '@/controllers/BusinessProductApis'
    import PoAiApi from '@/controllers/PoAi'
    import LocationComplianceApis from '@/controllers/LocationComplianceApis';
    import PricingGroupApis from "@/controllers/PricingGroup";

    import Helper from '@/helpers/index'
    import downloadCsv from 'vue-json-csv'
    import writeXlsxFile from 'write-excel-file';
    import {csv2json} from 'json-2-csv';
    import readXlsxFile from 'read-excel-file'
    
    export default defineComponent({
        props: ['payload', 'showTendyUpload'], //  showTendyUpload true show tendy upload else ocs or aglc upload
        components: {
            downloadCsv
        },
        setup() {
            const snackbar = useSnackbar();
            const error = false
            const errorMsg = ''
            const expandError = ref(false)
            let file = ref("")
            const poTendyType = ref('')
            const uploadType = ref('')
            const showDropDown = ref(false)
            let fulfillTime = ref("")
            const ocsFields = ['ShipmentID','ContainerID','SKU','ItemName','UnitPrice','Vendor','Brand','ComplianceType','CaseGTIN','PackagedOnDate','BatchLot','GTINBarCode','EachGTIN','Shipped_Qty','UOM','UOMCONVERSIONQTY','THC','CBD','ConcentrationUnit','TotalTerps']
            const aglcFields = ['Order Number','SKU','Shipped Each Qty','Case GTIN','Each GTIN','Lot Code','Price Per Unit','SKU Description','Brand Name','Product Name','Strain','ComplianceType','THC Pre-Fix','THC Min','THC Max','THC UOM','CBD Pre-Fix','CBD Min','CBD Max','CBD UOM','Dominant Terpene','Shipped Case Qty','Master Case Each Qty']
            const tendyFields = ['productId','Master Product Name','Variant Product Name','Category','Compliance Type','Cost','Price','Sale Price','Barcode/GTIN','Qty','Brand','SKU','Strain','Lot Tracking Enabled','Short Description','Long Description','Image (starred)','Image 2','Image 3','Concentration Unit','THC/CBD Value Type','Dry Cannabis Equivalency','THC','CBD','Lot THC','Lot CBD','Lot Cost','PackagedOnDate','BatchLot','Terp','Licensed Producer','Fulfilment time','Case Size','Exempt From Scanning']
            const otherOptions = ref([])
            const selectedOther = ref('')
            const downloadableCsv = ref([])
            const hasPriceColumn = ref(false)
            // price warning modal
            const priceWarning = ref({
                modal: false,
                data: []
            })

            return {snackbar, error, errorMsg, expandError, file, poTendyType, uploadType, showDropDown, selectedOther, fulfillTime, ocsFields, aglcFields, tendyFields, otherOptions, downloadableCsv, hasPriceColumn, priceWarning}
        },
        computed: {
            ...mapGetters({
                vg_selectedLocation: 'location/selected',
                vg_selectedBusiness: 'auth/activeBusiness',
            }),
        },
        mounted(){
            this.getComplianceProvider()
            if(this.poTendyType!=='tendy'){
                this.fetchAiPrompts()
            }
        },
        methods: {
            async getComplianceProvider(){
                if(this.showTendyUpload){
                    this.poTendyType = 'tendy'
                    this.uploadType = 'tendy'
                }else{
                    let res = await LocationComplianceApis.fetch();
                    if(res?.data?.payload?.providerName){
                        this.poTendyType = res.data.payload.providerName
                        this.uploadType = res.data.payload.providerName
                        // show other options if uploadType is mbll
                        if(res.data.payload.providerName=='mbll'){
                            this.uploadType = 'other'
                            this.showDropDown = true
                        }
                    }else{
                        this.poTendyType = 'ocs'
                        this.uploadType = 'ocs'
                    }
                }
            },
            async fetchAiPrompts(){
                let res = await PoAiApi.fetchAll(false);
                this.otherOptions = res.data.payload.aiPrompts
            },
            selectUploadType(type){
                this.uploadType = type
                if(type=='other'){
                    this.showDropDown = true
                }
            },
            selectOtherType(type){
                this.confirmNew('', '<div class="flex flex-col items-center justify-center gap-5"><svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.2648 56C6.77591 56 6.33147 55.8778 5.93147 55.6333C5.53147 55.3889 5.22036 55.0667 4.99814 54.6667C4.77591 54.2667 4.65369 53.8333 4.63147 53.3667C4.60925 52.9 4.73147 52.4444 4.99814 52L29.6648 9.33333C29.9315 8.88889 30.2759 8.55556 30.6981 8.33333C31.1204 8.11111 31.5537 8 31.9981 8C32.4426 8 32.8759 8.11111 33.2981 8.33333C33.7204 8.55556 34.0648 8.88889 34.3315 9.33333L58.9981 52C59.2648 52.4444 59.387 52.9 59.3648 53.3667C59.3426 53.8333 59.2204 54.2667 58.9981 54.6667C58.7759 55.0667 58.4648 55.3889 58.0648 55.6333C57.6648 55.8778 57.2204 56 56.7315 56H7.2648ZM31.9981 48C32.7537 48 33.387 47.7444 33.8981 47.2333C34.4092 46.7222 34.6648 46.0889 34.6648 45.3333C34.6648 44.5778 34.4092 43.9444 33.8981 43.4333C33.387 42.9222 32.7537 42.6667 31.9981 42.6667C31.2426 42.6667 30.6092 42.9222 30.0981 43.4333C29.587 43.9444 29.3315 44.5778 29.3315 45.3333C29.3315 46.0889 29.587 46.7222 30.0981 47.2333C30.6092 47.7444 31.2426 48 31.9981 48ZM31.9981 40C32.7537 40 33.387 39.7444 33.8981 39.2333C34.4092 38.7222 34.6648 38.0889 34.6648 37.3333V29.3333C34.6648 28.5778 34.4092 27.9444 33.8981 27.4333C33.387 26.9222 32.7537 26.6667 31.9981 26.6667C31.2426 26.6667 30.6092 26.9222 30.0981 27.4333C29.587 27.9444 29.3315 28.5778 29.3315 29.3333V37.3333C29.3315 38.0889 29.587 38.7222 30.0981 39.2333C30.6092 39.7444 31.2426 40 31.9981 40Z" fill="#FCB852"/></svg><span>Warning</span><span>This purchase order file will be read by AI and <strong>requires your review</strong>. It may contain incorrect details, so please verify all information before approving.</span></div>', 'Continue', 'bg-theme-green hover:bg-opacity-70 text-white', 'Cancel', '', false, true).then(async () => {
                    this.selectedOther = type
                    this.showDropDown = false
                }).catch(err => {
                    console.log(err)
                })
            },
            close(){
                this.$emit('close')
            },
            closePriceWarningModal(){
                this.priceWarning.modal = false
            },
            async addFile(e){
                this.error = false
                this.errorMsg = ''
                let fileList = e.target.files || e.dataTransfer.files
                if(fileList && fileList[0]){
                    this.file = fileList[0]
                    this.checkPriceColumnInUpload()
                }
            },
            async checkForWarning(){
                if(this.vg_selectedLocation.id){
                    if(this.showTendyUpload){
                        if(this.hasPriceColumn){
                            this.vm_spinner(true);
                            let res = await PricingGroupApis.priceWarning(this.vg_selectedLocation.id)
                            if(res.status==200 && res.data.payload && res.data.payload.groupLocations.length>0){
                                this.priceWarning = {
                                    modal: true,
                                    title: 'This pricing change will affect the following locations:',
                                    data: res.data.payload,
                                }
                                this.vm_spinner(false);
                            }else{
                                await this.uploadFile()
                            }
                        }else{
                            await this.uploadFile()
                        }
                    }else{
                        await this.uploadFile()
                    }
                }else{
                    this.snackbar.add({
                        type: 'info',
                        text: 'Please select location from top left corner',
                        duration: 3000,
                    })
                }
            },
            async checkPriceColumnInUpload(){
                let self = this
                let ext = Helper.getExtension(this.file.name)
                if(ext==='csv'){
                    let reader = new FileReader();
                    reader.readAsText(this.file);
                    reader.onload = async function() {
                        let result = reader.result;
                        let header = await csv2json(result)
                        if('Price' in header[0]){
                            self.hasPriceColumn = true
                        }else{
                            self.hasPriceColumn = false
                        }
                    };
                }else if(ext=='xlsx' || ext=='xls' || ext=='xlsm'){
                    let header = await readXlsxFile(this.file)
                    if(header[0].includes('Price')){
                        this.hasPriceColumn = true
                    }else{
                        this.hasPriceColumn = false
                    }
                }
            },
            async uploadFile(){
                if(this.file){
                    this.vm_spinner(true)
                    let fileData = new FormData()
                    fileData.append('importFile', this.file)
                    fileData.append('locationId', this.vg_selectedLocation.id)
                    fileData.append('fullfillmentTime', this.fulfillTime)
                    if(this.poTendyType==='aglc'){
                        fileData.append('fileType', 'aglc-purchase')
                    }
                    if(this.uploadType==='other'){
                        fileData.append('promptId', this.selectedOther.id)
                    }
                    let res = null
                    if(this.poTendyType=='tendy'){
                        res = await ProductApi.importUploadTendyUpload(fileData)
                    }else if(this.poTendyType=='aglc' || this.poTendyType=='ocs' || this.poTendyType=='mbll'){
                        res = await ProductApi.purchaseOrderUpload(fileData)
                    }
                    if(res.status==201){
                        this.snackbar.add({
                            type: 'info',
                            text: "Uploaded successfully.",
                            duration: 3000,
                        })
                    }else{
                        this.errorMsg = res.response?.data?.message
                        this.error =true
                    }
                    this.priceWarning.modal = false
                    this.vm_spinner(false)
                    this.clearFile()
                    if(res.data?.payload){
                        if(this.poTendyType=='tendy'){
                            this.emitter.emit("reloadProductList")
                            this.$emit('close')
                        }else if(res.data.payload?.payload?.id){
                            this.$router.push({name: 'AddPurchaseOrders', params: {id: res.data.payload.payload.id}})
                        }
                    }
                    
                }
            },
            async createXlSheet(){
                let schema = []
                let fields = this.poTendyType=='tendy'?this.tendyFields:(this.poTendyType==='aglc'?this.aglcFields:this.ocsFields)
                for(let i=0; i<fields.length; i++){
                    schema.push({
                        column: fields[i],
                        type: String,
                        wrap: true,
                        value: ''
                    })
                }
                await writeXlsxFile([], {
                    schema: schema,
                    fileName: `${this.poTendyType=='tendy'?'tendy':this.poTendyType}-template.xlsx`
                });
            },
            clearFile(){
                this.file = ""
                this.$refs.uploadFile.value = ''
                // this.downloadableCsv = []
            },
            preventNonNumbersAndDecimal(e) {
              var ASCIICode = (e.which) ? e.which : e.keyCode
              if(ASCIICode == 43 || ASCIICode == 45 || ASCIICode == 101 || e.which == 8 || ASCIICode !== 46 && ASCIICode != 0 && (ASCIICode < 48 || ASCIICode > 57)){
                return false
              }
              return true;
            },
            expandNow(){
                this.expandError = true
            },
            collapseNow(){
                this.expandError = false
            },
            ...mapMutations({
                vm_spinner: 'spinner/mutateSpinner'
            })
        }
    })
    </script>
    <style>
    .custom-modal-wrap:before {
      content: '';
      position: fixed;
      top: 0;
      width: 0;
      height: 100%;
      width: 100%;
      background: rgb(0 0 0 / 64%);
    }
    </style>